import {AIDVGenerationPreset} from '../../auto-generate-drilldown-dialog/data-access/models/auto-generate-drilldown-payload.interface';

export interface AIStoryGenerationStatus {
  total: number;
  completed: number;
  failed: number;
}

export interface AIDVGenerationError {
  code?: number;
  reason?: string;
}

export interface AIDVRetry {
  available?: boolean;
  link?: string;
  preset?: AIDVGenerationPreset;
}

export const GENERATION_TYPE = {
  TOP_LEVEL: 'topLevel',
  DRILLDOWN: 'drilldown'
} as const;

export interface AIDVGenerationStatus {
  inProgress?: boolean;
  error?: AIDVGenerationError;
  failed?: boolean;
  finished?: boolean;
  requestZoom?: boolean;
  text?: string;
  loading?: boolean;
  step?: string;
  reposition?: boolean;
  retry?: AIDVRetry;
  type?: (typeof GENERATION_TYPE)[keyof typeof GENERATION_TYPE];
}

export enum GENERATION_STATUSES {
  IN_PROGRESS = 'inProgress',
  FAILED = 'failed',
  FINISHED = 'finished'
}

export interface AIRecommendationsGenerationProgress {
  text: string;
  status: GENERATION_STATUSES;
  startedAt?: string;
}
